var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "modal",
      attrs: {
        width: _vm.$isMobile() ? "425" : "800",
        title: "Produtos ativos",
        "close-icon": "",
        "buttons-position": "right",
      },
      on: { close: _vm.close, confirm: _vm.confirm },
    },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("AppInput", {
            staticClass: "search__input",
            attrs: {
              placeholder: "Digite o nome do produto ou SKU",
              "prepend-inner-icon": "search",
            },
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search__buttons" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", dark: "" },
                  on: { click: _vm.onSearch },
                },
                [_vm._v("\n        Buscar\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: { click: _vm.onClean },
                },
                [_vm._v("\n        Limpar\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.products
        ? _c("AppTable", {
            attrs: {
              headers: _vm.headers,
              items: _vm.products,
              loading: _vm.loading,
              selected: _vm.selecteds,
              "checkbox-table": "",
              "select-all-check-box": "",
              "hide-title": "",
            },
            on: {
              "table:remove-selecteds": _vm.onRemoveAllCurrentPage,
              "table:selected-item": _vm.onSelectItem,
              "table:selected-all": _vm.onSelectAll,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "d-flex align-center mx-4" },
        [
          _c("v-icon", { staticClass: "mr-1" }, [_vm._v("info_outline")]),
          _vm._v(
            "\n    Não encontrou o produto que precisa? Talvez ele não esteja cadastrado, esteja inativo ou sendo utilizado em outra promoção.\n  "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppPagination", {
        attrs: {
          length: _vm.pagination.pageCount,
          currentPagination: _vm.pagination.currentPagination,
        },
        on: { onPagination: _vm.onPagination },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }